import styled from 'styled-components';

import { FLEX_WRAPPER } from '@pkg/components/Sections/Admin/Users/styles';

export const UserListActionWrapper = styled.div`
    ${FLEX_WRAPPER};
    flex-wrap: wrap;
`;

export const UserListActionItem = styled.div`
    margin: 0 5px 5px 0;
    button {
        font-size: 9px;
        padding: 4px;
    }
`;
